import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import OrganisationTableRowViewModel from './ViewModels/OrganisationTableRowViewModel';
import { useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import IconButton from '@mui/material/IconButton';
import dayjs from 'dayjs';

interface IProps {
    row: OrganisationTableRowViewModel;
    refresh: () => void;
    viewOrg: (id: string) => void;
}

export default function OrganisationRow(props: IProps) {
    const { row, viewOrg } = props;
    const [open, setOpen] = useState(false);

    const setOrgId = () => {
        viewOrg(row.id);
    }

    return (
        <>
            <TableRow onClick={setOrgId} sx={{
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: 'action.hover',
                },
            }}>
                <TableCell>{row.organisationName}{row.archived ? ' (Archived)' : ''}</TableCell>
                <TableCell>{row.licenseType}</TableCell>
                <TableCell>{row.expiryDate ? dayjs(row.expiryDate).format("DD/MM/YYYY") : ''}</TableCell>
                <TableCell>{row.renewalDate ? dayjs(row.renewalDate).format("DD/MM") : ''}</TableCell>
                <TableCell>{row.invoicePayPeriod}</TableCell>
                <TableCell>{row.invoicePayMethod}</TableCell>
                <TableCell>{row.invoiceNotice}</TableCell>
                <TableCell>{row.estimateNotice}</TableCell>
                <TableCell>
                    {row.sites.length == 1 ?
                        `${row.sites[0].officeName}, ${row.sites[0].town}`
                        :
                        <span>{`${row.sites.length} sites`}
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpen(!open)}
                            >
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </span>
                    }
                </TableCell>
            </TableRow>
            {(open && row.sites.length > 1) && row.sites.map((siteRow) => (
                <TableRow key={siteRow.id}>
                    <TableCell colSpan={9} align="right">{`${siteRow.officeName}, ${siteRow.town}`}</TableCell>
                </TableRow>
            ))}
        </>
    );
}
